import { IndustryConfig } from './industry-config.interface';
import { IndustryType } from './industry-types.enum';

/**
 * Mobile Industry Configuration
 * Mobile phone sales with enhanced features:
 * - Product mapping and variants
 * - Free quantity management
 * - Industry-specific API routing
 */
export const MobileIndustryConfig: IndustryConfig = {
    industryType: IndustryType.MOBILE,
    name: 'Mobile',
    apiPathSegment: 'mobile', // API calls will be routed to /v1/mobile/...
    features: {
        enableFreeQuantity: true,
        enableMapping: true,
        enableVariants: true,
        enableTableManagement: false,
        enableKitchenDisplay: false,
        productSearchFields: ['mapping', 'variants'],
        orderPlacementFields: ['mapping', 'variants', 'free_items'],
    },
};
